var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"inline",style:(`object-position: ${_vm.stylePosition};`),attrs:{"src":_vm.srcPath,"alt":_vm.imageValues.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }